var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoProjectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 44,
    height: 40,
    transform: "translate(0 0.211)",
    fill: "#cea95a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3033",
    "data-name": "Groupe 3033",
    transform: "translate(0 -0.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3032",
    "data-name": "Groupe 3032",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36702",
    "data-name": "Trac\\xE9 36702",
    d: "M40.211,30.9H36.752a8.854,8.854,0,0,0-16.692,0H3.32A3.324,3.324,0,0,0,0,34.225V47.505a3.324,3.324,0,0,0,3.32,3.32H6.484l.732,3.415a2.224,2.224,0,0,0,2.164,1.75h3.007a2.224,2.224,0,0,0,2.164-1.75l.732-3.415H28.249l.732,3.415a2.224,2.224,0,0,0,2.164,1.75h3.007a2.224,2.224,0,0,0,2.164-1.75l.732-3.415h3.163a3.324,3.324,0,0,0,3.32-3.32V34.225a3.324,3.324,0,0,0-3.32-3.32M28.406,27.216a6.64,6.64,0,1,1-6.64,6.64,6.64,6.64,0,0,1,6.64-6.64M12.387,53.777H9.38l-.633-2.951h4.272Zm21.766,0H31.145l-.633-2.951h4.272Zm7.165-6.271a1.107,1.107,0,0,1-1.107,1.107H3.32a1.107,1.107,0,0,1-1.107-1.107v-3.32h9.012a1.107,1.107,0,1,0,0-2.213H2.213V39.021h9.012a1.107,1.107,0,1,0,0-2.213H2.213V34.225A1.107,1.107,0,0,1,3.32,33.118H19.585c-.02.243-.033.489-.033.738a8.854,8.854,0,1,0,17.708,0c0-.249-.013-.494-.033-.738h2.984a1.107,1.107,0,0,1,1.107,1.107Z",
    transform: "translate(0 -15.779)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36703",
    "data-name": "Trac\\xE9 36703",
    d: "M70.689,46.378A3.689,3.689,0,1,0,67,42.689a3.689,3.689,0,0,0,3.689,3.689m0-5.165a1.476,1.476,0,1,1-1.476,1.476,1.476,1.476,0,0,1,1.476-1.476",
    transform: "translate(-42.283 -24.613)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36704",
    "data-name": "Trac\\xE9 36704",
    d: "M54.869,77h1.476a.369.369,0,0,1,.369.369v1.476a.369.369,0,0,1-.369.369H54.869a.369.369,0,0,1-.369-.369V77.369A.369.369,0,0,1,54.869,77",
    transform: "translate(-34.395 -48.594)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36705",
    "data-name": "Trac\\xE9 36705",
    d: "M67.869,77h1.476a.369.369,0,0,1,.369.369v1.476a.369.369,0,0,1-.369.369H67.869a.369.369,0,0,1-.369-.369V77.369A.369.369,0,0,1,67.869,77",
    transform: "translate(-42.599 -48.594)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36706",
    "data-name": "Trac\\xE9 36706",
    d: "M80.869,77h1.476a.369.369,0,0,1,.369.369v1.476a.369.369,0,0,1-.369.369H80.869a.369.369,0,0,1-.369-.369V77.369A.369.369,0,0,1,80.869,77",
    transform: "translate(-50.803 -48.594)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36707",
    "data-name": "Trac\\xE9 36707",
    d: "M93.869,77h1.476a.369.369,0,0,1,.369.369v1.476a.369.369,0,0,1-.369.369H93.869a.369.369,0,0,1-.369-.369V77.369A.369.369,0,0,1,93.869,77",
    transform: "translate(-59.007 -48.594)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36708",
    "data-name": "Trac\\xE9 36708",
    d: "M56.107,5.36a1.108,1.108,0,0,0,.827-.371,8.272,8.272,0,0,1,12.364,0,1.107,1.107,0,0,0,1.654-1.471,10.486,10.486,0,0,0-15.673,0,1.107,1.107,0,0,0,.827,1.842",
    transform: "translate(-34.711 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36709",
    "data-name": "Trac\\xE9 36709",
    d: "M65.378,13.472a1.107,1.107,0,1,0,1.408,1.708l.018-.015a4.046,4.046,0,0,1,5.214,0,1.107,1.107,0,1,0,1.426-1.693,6.26,6.26,0,0,0-8.067,0Z",
    transform: "translate(-41.005 -7.573)",
    fill: "#cea95a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoProjectors);
export default __webpack_public_path__ + "static/media/iconVideoProjectors.5162ba459f79b9dec1d5c64aeafd0f1a.svg";
export { ForwardRef as ReactComponent };